<template>
  <div class="auth-page">
    <div class="auth-layout">
      <div class="visual-panel">
      </div>

      <section class="form-card">
        <div class="content">
          <div class="card-header">
            <!-- <span>创建账号</span> -->
            <h1>用户注册</h1>
            <p>注册页延续登录页布局，字段保持单列排列，方便后续继续扩展。</p>
          </div>

          <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-position="top"
            class="auth-form"
          >
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号" />
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input
                v-model="form.password"
                type="password"
                show-password
                placeholder="请输入密码"
              />
            </el-form-item>

            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input
                v-model="form.confirmPassword"
                type="password"
                show-password
                placeholder="请再次输入密码"
              />
            </el-form-item>

            <el-form-item label="手机验证码" prop="smsCode">
              <el-input v-model="form.smsCode" placeholder="请输入手机验证码">
                <template #suffix>
                  <button
                    type="button"
                    class="text-action"
                    :disabled="smsCountdown > 0"
                    @click="handleSendSmsCode"
                  >
                    {{ smsCountdown > 0 ? `已发送短信 ${smsCountdown}s` : '获取验证码' }}
                  </button>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button class="submit-btn" type="primary" @click="handleRegister">注册</el-button>
            </el-form-item>
          </el-form>

          <div class="switch-action">
            已有账号？
            <button type="button" @click="goLogin">立即登录</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import AuthVisualPanel from '@/components/AuthVisualPanel.vue'
import { isFixedSmsCode, isPhone } from '@/utils/validators'

const router = useRouter()
const formRef = ref()
const smsCountdown = ref(0)
let smsTimer = null

const form = reactive({
  phone: '',
  password: '',
  confirmPassword: '',
  smsCode: ''
})

const rules = {
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isPhone(value)) {
          callback(new Error('请输入正确的手机号格式'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (value !== form.password) {
          callback(new Error('两次输入的密码不一致'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  smsCode: [
    { required: true, message: '请输入手机验证码', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isFixedSmsCode(value)) {
          callback(new Error('手机验证码固定为 123456'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

function handleSendSmsCode() {
  if (smsCountdown.value > 0) {
    return
  }

  if (!isPhone(form.phone)) {
    ElMessage.warning('请先输入正确的手机号')
    return
  }

  ElMessage.success('短信已发送')
  smsCountdown.value = 60

  smsTimer = window.setInterval(() => {
    smsCountdown.value -= 1

    if (smsCountdown.value <= 0) {
      clearSmsTimer()
    }
  }, 1000)
}

function clearSmsTimer() {
  if (smsTimer) {
    window.clearInterval(smsTimer)
    smsTimer = null
  }

  smsCountdown.value = 0
}

function handleRegister() {
  formRef.value.validate((valid) => {
    if (!valid) {
      return
    }

    ElMessage.success('注册信息校验通过，请立即登录')
  })
}

function goLogin() {
  router.push('/login')
}

onBeforeUnmount(() => {
  clearSmsTimer()
})
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100%;
}

.auth-layout {
  display: flex;
  height: 100%;
  background: #fff;
  // flex: 1;
  // grid-template-columns: 1fr 1fr;
  // gap: 24px;
}

.form-card {
  width: 50%;
  height: calc(100vh - 84px - 70px);
  padding: 120px;
  // border-radius: 28px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-main);
}
.content {
  width: 600px;
}

.card-header {
  margin-bottom: 22px;
}

.card-header span {
  font-size: 13px;
  color: var(--primary);
}

.card-header h1 {
  margin: 8px 0 12px;
  font-size: 34px;
}

.card-header p {
  margin: 0;
  line-height: 1.7;
  color: var(--text-secondary);
}

.demo-alert {
  margin-bottom: 18px;
  border-radius: 16px;
}

:deep(.auth-form .el-form-item) {
  margin-bottom: 16px;
}

:deep(.auth-form .el-input__wrapper) {
  min-height: 44px;
  border-radius: 14px;
}

.text-action {
  padding: 0;
  border: 0;
  font-size: 14px;
  white-space: nowrap;
  color: #2563eb;
  cursor: pointer;
  background: transparent;
}

.text-action:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.submit-btn {
  width: 100%;
  min-height: 46px;
  border-radius: 14px;
  font-size: 16px;
}

.switch-action {
  margin-top: 8px;
  font-size: 14px;
  color: var(--text-secondary);
  display: flex;
  justify-content: center;
}

.switch-action button {
  padding: 0;
  border: 0;
  margin-left: 4px;
  font: inherit;
  color: var(--primary);
  cursor: pointer;
  background: transparent;
}
.visual-panel {
  width: 50%;
  // height: 700px;
    height: calc(100vh - 84px - 70px);
  // height: 100%;
  background: url('../assets/login2.png')no-repeat center center;
  background-size: cover;
}

@media (max-width: 900px) {
  .auth-layout {
    // grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .form-card {
height: calc(100vh - 84px - 70px);
    padding: 22px;
    border-radius: 20px;
  }

  .card-header h1 {
    font-size: 28px;
  }
}
</style>
